/**
 * Godu Blog JavaScript
 * Table of Contents and FAQ functionality for Godu Blog Post template
 */

document.addEventListener('DOMContentLoaded', function() {
    // Initialize all Godu blog features
    initGoduTOC();
    initGoduFAQ();
    initGoduBlogSlider();
    initGoduProgressBar();
});

/**
 * Table of Contents Generator
 * Scans for h2 and h3 headings in .godu-page-content and builds a clickable TOC
 */
function initGoduTOC() {
    const tocList = document.getElementById('godu-toc');
    const headings = document.querySelectorAll('.godu-page-content h2, .godu-page-content h3:not(.godu-special)');

    if (tocList && headings.length > 0) {
        headings.forEach((heading, index) => {
            if (!heading.classList.contains('godu-toc-header')) {
                // Generate unique ID for the heading
                if (!heading.id) {
                    heading.id = `godu-toc-heading-${index + 1}`;
                }

                // Create list item
                const li = document.createElement('li');
                li.textContent = heading.textContent;
                li.style.cursor = 'pointer';

                // Indent h3 headings
                if (heading.tagName.toLowerCase() === 'h3') {
                    li.style.marginLeft = '20px';
                }

                // Add click event for smooth scroll
                li.addEventListener('click', () => {
                    const headerOffset = 160; // Fixed header height
                    const elementPosition = heading.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                });

                tocList.appendChild(li);
            }
        });
    }
}

/**
 * FAQ Accordion
 * Handles expand/collapse of FAQ items with smooth animation
 */
function initGoduFAQ() {
    const faqHeadings = document.querySelectorAll('.godu-faq-item-heading');

    faqHeadings.forEach((heading) => {
        heading.addEventListener('click', function() {
            const faqBody = heading.nextElementSibling;
            const faqChevron = heading.querySelector('.godu-faq-item-chevron');

            if (faqBody && faqBody.classList.contains('godu-faq-item-body')) {
                if (faqBody.classList.contains('godu-faq-open')) {
                    // Close the FAQ
                    faqBody.classList.remove('godu-faq-open');
                    if (faqChevron) {
                        faqChevron.classList.remove('godu-rotate-180');
                    }
                } else {
                    // Open the FAQ
                    faqBody.classList.add('godu-faq-open');
                    if (faqChevron) {
                        faqChevron.classList.add('godu-rotate-180');
                    }
                }
            }
        });
    });
}

/**
 * Godu Blog Slider
 * Initialize Swiper for related blogs carousel
 */
function initGoduBlogSlider() {
    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
        console.warn('Swiper is not loaded. Godu blog slider will not work.');
        return;
    }

    const blogSliders = document.querySelectorAll('.godu-blogs-slider');

    blogSliders.forEach((slider) => {
        new Swiper(slider, {
            slidesPerView: 1.4,
            spaceBetween: 24,
            grabCursor: true,
            loop: false,
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                576: {
                    slidesPerView: 2.4,
                },
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
        });
    });
}

/**
 * Progress Bar
 * Shows reading progress for article
 */
function initGoduProgressBar() {
    const progressBar = document.getElementById('godu-progressbar');
    const progressBarMobile = document.getElementById('godu-progressbar-mobile');

    if (!progressBar && !progressBarMobile) return;

    window.addEventListener('scroll', () => {
        const column = document.querySelector('.godu-main-article-wrapper');

        if (!column) return;

        const scrollTop = window.scrollY;
        const columnRect = column.getBoundingClientRect();
        const columnTop = columnRect.top + scrollTop;
        const columnBottom = columnTop + columnRect.height;
        const viewportHeight = window.innerHeight;

        const columnStart = columnTop;
        const columnEnd = columnBottom - viewportHeight;

        let scrollPercent = 0;

        if (scrollTop >= columnStart && scrollTop <= columnEnd) {
            scrollPercent = ((scrollTop - columnStart) / (columnEnd - columnStart)) * 100;
        } else if (scrollTop > columnEnd) {
            scrollPercent = 100;
        }

        scrollPercent = Math.max(0, Math.min(100, scrollPercent));

        if (progressBar) progressBar.style.width = scrollPercent + '%';
        if (progressBarMobile) progressBarMobile.style.width = scrollPercent + '%';
    });
}